module.exports = __webpack_public_path__ + "static/media/nicolas_capaldo.db27e8b7.jpg";